export const QUESTIONS = [
  'Did the person who died leave a will?',
  [
    'Is there anyone who might challenge what’s in the will?',
    {
      question: 'Who is their next of kin?',
      answers: [
        'Their spouse or civil partner',
        'Their child',
        'Their sibling',
        'Someone else',
        'Not sure',
      ],
    },
  ],
  [
    'Does the will include more than five beneficiaries?',
    'Is there anyone who’s unhappy with what they might receive from the estate?',
  ],
  'Did the person who died own any property?',
  'Did they own anything in another country?',
  'Did they have more than 10 bank accounts, pensions or life insurance policies?',
  'Will there be inheritance tax to pay on the estate?',
  'Are you the person applying for probate?',
  'Has the application already been submitted?',
]

export const DEFAULT_ANSWERS = ['Yes', 'No', 'Not sure']

export const BASELINES = {
  probateMin: 2,
  probateMax: 3,
  estateAdminMin: 3,
  estateAdminMax: 6,
}

const DEFAULT_ANSWER_VALUES = {
  probateMin: 0,
  probateMax: 0,
  estateAdminMin: 0,
  estateAdminMax: 0,
}

export const ANSWER_VALUES_MAP = [
  {
    yes: DEFAULT_ANSWER_VALUES,
    no: DEFAULT_ANSWER_VALUES,
    'not sure': DEFAULT_ANSWER_VALUES,
  },
  {
    true: {
      yes: {
        probateMin: 1,
        probateMax: 3,
        estateAdminMin: 3,
        estateAdminMax: 6,
        notes: {
          probate: 'The dispute over the will is resolved quickly',
          estateAdmin:
            'The dispute over the will is resolved before you apply for probate',
        },
      },
      no: DEFAULT_ANSWER_VALUES,
      'not sure': {
        probateMin: 1,
        probateMax: 3,
        estateAdminMin: 3,
        estateAdminMax: 6,
        notes: {
          probate: 'Any disputes over the will are resolved quickly',
          estateAdmin:
            'Any disputes over the will are resolved before you apply for probate',
        },
      },
    },
    false: {
      'their spouse or civil partner': {
        probateMin: 0,
        probateMax: 0,
        estateAdminMin: -1,
        estateAdminMax: -3,
      },
      'their child': {
        probateMin: 0,
        probateMax: 1,
        estateAdminMin: 1,
        estateAdminMax: 1,
        notes: {
          probate: 'Documents can easily be found to prove who is next of kin',
          estateAdmin:
            'It’s easy to find documents proving how each beneficiary is related to the person who died',
        },
      },
      'their sibling': {
        probateMin: 1,
        probateMax: 1,
        estateAdminMin: 1,
        estateAdminMax: 2,
        notes: {
          probate:
            'Certificates can easily be found to prove who is next of kin',
          estateAdmin:
            'It’s easy to find documents proving how each beneficiary is related to the person who died',
        },
      },
      'someone else': {
        probateMin: 1,
        probateMax: 1,
        estateAdminMin: 3,
        estateAdminMax: 6,
        notes: {
          probate:
            'Certificates can easily be found to prove who is next of kin',
          estateAdmin:
            'It’s easy to find documents proving how each beneficiary is related to the person who died',
        },
      },
      'not sure': {
        probateMin: 1,
        probateMax: 1,
        estateAdminMin: 3,
        estateAdminMax: 6,
        notes: {
          probate: 'The next of kin can be tracked down easily',
          estateAdmin:
            'It’s easy to find documents proving how each beneficiary is related to the person who died',
        },
      },
    },
  },
  {
    true: {
      yes: {
        probateMin: 0,
        probateMax: 0,
        estateAdminMin: 1,
        estateAdminMax: 3,
        notes: {
          estateAdmin:
            'It’s easy to get hold of each beneficiary’s contact details and proof of identity',
        },
      },
      no: DEFAULT_ANSWER_VALUES,
      'not sure': {
        probateMin: 0,
        probateMax: 0,
        estateAdminMin: 1,
        estateAdminMax: 3,
        notes: {
          estateAdmin:
            'It’s easy to get hold of each beneficiary’s contact details and proof of identity',
        },
      },
    },
    false: {
      yes: {
        probateMin: 1,
        probateMax: 3,
        estateAdminMin: 3,
        estateAdminMax: 6,
        notes: {
          probate: 'Any disputes can be resolved quickly',
          estateAdmin:
            'Any disputes over who gets what can be resolved quickly',
        },
      },
      no: DEFAULT_ANSWER_VALUES,
      'not sure': {
        probateMin: 1,
        probateMax: 3,
        estateAdminMin: 3,
        estateAdminMax: 6,
        notes: {
          probate: 'Any disputes can be resolved quickly',
          estateAdmin:
            'Any disputes over who gets what can be resolved quickly',
        },
      },
    },
  },
  {
    yes: {
      probateMin: 0,
      probateMax: 1,
      estateAdminMin: 1,
      estateAdminMax: 2,
      notes: {
        probate:
          'You’ve already got details of all bank accounts, pension plans and other financial assets',
        estateAdmin: 'The funds in each account are below the probate treshold',
      },
    },
    no: DEFAULT_ANSWER_VALUES,
    'not sure': {
      probateMin: 0,
      probateMax: 1,
      estateAdminMin: 1,
      estateAdminMax: 2,
      notes: {
        probate:
          'You’ve already got details of all bank accounts, pension plans and other financial assets',
        estateAdmin: 'The funds in each account are below the probate treshold',
      },
    },
  },
  {
    yes: {
      probateMin: 0,
      probateMax: 1,
      estateAdminMin: 1,
      estateAdminMax: 2,
      notes: {
        probate: 'Any property that needs to be sold can be valued quickly',
        estateAdmin:
          'The property can be put on the market and sold fairly quickly',
      },
    },
    no: DEFAULT_ANSWER_VALUES,
    'not sure': {
      probateMin: 0,
      probateMax: 1,
      estateAdminMin: 1,
      estateAdminMax: 2,
      notes: {
        probate: 'Any property that needs to be sold can be valued quickly',
        estateAdmin: 'There isn’t any property that needs to be sold',
      },
    },
  },
  {
    yes: {
      probateMin: 1,
      probateMax: 3,
      estateAdminMin: 6,
      estateAdminMax: 6,
      notes: {
        probate: 'The assets in another country can be valued quickly',
        estateAdmin: 'Probate isn’t required for any assets in another country',
      },
    },
    no: DEFAULT_ANSWER_VALUES,
    'not sure': {
      probateMin: 1,
      probateMax: 3,
      estateAdminMin: 6,
      estateAdminMax: 6,
      notes: {
        probate: 'Any assets in another country can be valued quickly',
        estateAdmin: 'Probate isn’t required for any assets in another country',
      },
    },
  },
  {
    yes: {
      probateMin: 1,
      probateMax: 3,
      estateAdminMin: 6,
      estateAdminMax: 6,
      notes: {
        probate: 'It’s easy to work out the full value of the estate',
        estateAdmin: 'HMRC confirms that all inheritance tax due has been paid',
      },
    },
    no: DEFAULT_ANSWER_VALUES,
    'not sure': {
      probateMin: 1,
      probateMax: 3,
      estateAdminMin: 6,
      estateAdminMax: 6,
      notes: {
        probate: 'Inheritance tax doesn’t need to be paid on the estate',
        estateAdmin: 'Inheritance tax doesn’t need to be paid on the estate',
      },
    },
  },
  {
    yes: {
      probateMin: 0,
      probateMax: 0,
      estateAdminMin: 0,
      estateAdminMax: 0,
    },
    no: DEFAULT_ANSWER_VALUES,
    'not sure': {
      probateMin: 0,
      probateMax: 0,
      estateAdminMin: 0,
      estateAdminMax: 0,
    },
  },
  {
    yes: {
      probateMin: 0,
      probateMax: 0,
      estateAdminMin: 0,
      estateAdminMax: 0,
    },
    no: DEFAULT_ANSWER_VALUES,
    'not sure': {
      probateMin: 0,
      probateMax: 0,
      estateAdminMin: 0,
      estateAdminMax: 0,
    },
    skipped: {
      probateMin: 0,
      probateMax: 0,
      estateAdminMin: 0,
      estateAdminMax: 0,
    },
  },
]
